import { render, staticRenderFns } from "./json-component.vue?vue&type=template&id=19d3aeac&scoped=true"
import script from "./json-component.vue?vue&type=script&lang=js"
export * from "./json-component.vue?vue&type=script&lang=js"
import style0 from "./json-component.vue?vue&type=style&index=0&id=19d3aeac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d3aeac",
  null
  
)

export default component.exports